module.exports = __webpack_public_path__ + "static/media/logo.fb6d5b78.png";